$(function() {

    var window_width, window_md = 989;

    //商品詳細のアコーディオン
    $(".js-acc-title").click(function() {

        $(this).next('.js-acc-content').slideToggle();
        $(this).toggleClass('js-active');
        return false;
    });


    //Gナビ
    $(".js-gnav-menu").click(function() {
        window_width = $(window).width();
        if (window_width > window_md) {
            $(this).next('.js-gnav-content').slideToggle();
            $(this).toggleClass('js-active');
            return false;
        }
    });

    //Product closeボタン
    $(".js-products-close").click(function() {
        window_width = $(window).width();
        if (window_width > window_md) {
            $(this).parent('.js-gnav-content').slideToggle();
            $('.js-gnav-menu').toggleClass('js-active');
            return false;
        }
    });

    //smooth scroll
    $(".js-scroll").click(function() {
        window_width = $(window).width();

        var $target = $(this).attr("href");
        var $scroll_top = $($target).offset().top;
        // if (window_width <= window_sp) {

        //     $scroll_top = $($target).offset().top + 2 - nav_height_sp;
        // }

        $("html,body").animate({
            scrollTop: $scroll_top
        }, 800, 'swing');
        return false;
    });


    // slick
    // --------------------------------------------------------


    //商品ページSP
    function checkBreakPoint() {
        w = $(window).width();
        if (w <= 749) {
            // スマホ向け（767px以下のとき）
            $('.js-slick-mv').not('.slick-initialized').slick({
                dots: true,
                infinite: true,
                speed: 800,
                fade: false,
                autoplay: true,
                autoplaySpeed: 5000,
                accessibility: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                pauseOnDotsHover: false,
                slidesToShow: 1,
                centerPadding: '10%',
                centerMode: false,
                arrows: false
            });
        } else {
            // PC向け
            $('.js-slick-mv').slick('unslick');
        }
    }
    // ウインドウがリサイズする度にチェック
    $(window).resize(function() {
        checkBreakPoint();
    });
    // 初回チェック
    checkBreakPoint();


    //shop&bar
    $(".js-slick-shopbar").slick({
        dots: true,
        infinite: true,
        speed: 1000,
        fade: false,
        autoplay: true,
        autoplaySpeed: 5000,
        accessibility: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        centerPadding: '10%',
        centerMode: false,
        arrows: false
    });




});